import { AnalyticsService } from 'base/analytics';
import { useProjectConnectionState } from 'base/extensions/hooks/use_project_connection_state';
import { LibraryCache } from 'base/library_cache';
import { BlocksService } from 'blocks/blocks_service';
import { Page } from 'blocks/editor/model';
import { unrefSection } from 'blocks/editor/model_helpers';
import React from 'react';
import { PageSwitcher } from './page_switcher';
import { Section } from './section';
import styles from './viewer.css';

function resolvePage(page: Page, route: string[]): Page | undefined {
  if (route.length === 0) {
    return page;
  }
  const [segment, ...rest] = route;
  const target = page.subPages.find((subPage) => subPage.name === segment);
  if (target) {
    return resolvePage(target, rest);
  }
}

const loader = <div>Loading...</div>;

export function Viewer({
  path,
  blocksService,
  analyticsService,
  library,
}: {
  path: string;
  blocksService: BlocksService;
  analyticsService: AnalyticsService;
  library: LibraryCache;
}) {
  const [projectToken, ...route] = decodeURIComponent(path)
    .replace('/app/preview/', '')
    .split('/')
    .filter(Boolean);
  const [, connectionError, project] = useProjectConnectionState(
    projectToken,
    blocksService,
    analyticsService,
  );
  if (connectionError != null) {
    return <div>Error loading project</div>;
  }
  if (!project) {
    return loader;
  }
  const page = resolvePage(project.homePage, route);
  if (page == null) {
    return <div>Not found</div>;
  }
  return (
    <React.Suspense fallback={loader}>
      <div className={styles.viewer}>
        <div className={styles.content}>
          {page.sections.map((section, index) => (
            <Section
              key={index}
              section={unrefSection(section, project)!}
              library={library}
            />
          ))}
        </div>
        <div className={styles.widget}>
          <PageSwitcher
            page={project.homePage}
            base={`/app/preview/${projectToken}`}
          />
        </div>
      </div>
    </React.Suspense>
  );
}
